export const locationHelper = {
  googleDirectionsUrl,
};

/**
 * Get google directions url
 * @param  {[type]} origin      [description]
 * @param  {[type]} destination [description]
 * @return {[type]}             [description]
 */
function googleDirectionsUrl({origin, destination}) {
  let googleUrl = 'https://www.google.com/maps/dir/?api=1';
  if (origin) {
    googleUrl += `&origin=${origin}`;
  }
  if (destination) {
    googleUrl += `&destination=${destination}`;
  }
  return googleUrl;
}
